import React from 'react';
import Tooltip from '../UI/Tooltip';
import './pricingtable.css';
import { userAppContext } from '../../Context/Context';
import { useAcademicApplication } from '../../hooks/useAcademicApplication';
import pricingData from './pricingData.json';
import { UserContext } from '../../types';

function PricingTables() {
  const { user, isAuthenticated, groups } = userAppContext() as unknown as UserContext;
  const { trialType, userType } = useAcademicApplication(user?.email, isAuthenticated);
  const isTrial = groups?.includes('ROLE_TRIAL');
  const isCommercial = isTrial ? trialType === 'commercial' : userType === 'commercial';

  const visibleColumns = pricingData.columns.filter(col => (isCommercial ? col.showForCommercial : true));

  const renderCellContent = cellData => {
    if (!cellData) return null;

    if (cellData.type === 'icon') {
      const iconClass =
        cellData.value === 'x-circle'
          ? 'bi bi-x-circle-fill x-circle'
          : `bi bi-check-circle-fill ${cellData.value}`;

      return (
        <>
          <i className={iconClass}></i>
          {cellData.asterisk && <i className="position-absolute">*</i>}
        </>
      );
    }

    return cellData.value;
  };

  const renderLabel = row => {
    const content = (
      <span className="table-subsubtitles">
        {row.label}
        {row.tooltip && (
          <>
            {' '}
            <Tooltip content={row.tooltip}>
              <i className="bi bi-info-circle"></i>
            </Tooltip>
          </>
        )}
      </span>
    );

    if (row.link) {
      return (
        <a href={row.link} target="_blank" rel="noopener noreferrer">
          <u className="table-subsubtitles" style={{ color: ' #52B7DB' }}>
            {row.label}
          </u>
        </a>
      );
    }

    return content;
  };

  return (
    <div>
      <table
        className="table panther-table table-edit sticky"
        style={{ margin: '10px auto 10px', textAlign: 'center' }}
      >
        <thead>
          <tr className="table-titles">
            <th></th>
            {visibleColumns.map(col => (
              <th key={col.id}>{col.label}</th>
            ))}
          </tr>
        </thead>

        {pricingData.sections.map((section, sectionIdx) => (
          <tbody key={sectionIdx}>
            <tr>
              <th className="table-subtitles">{section.title}</th>
              <th className="table-subtitles" colSpan={visibleColumns.length}></th>
            </tr>
            {section.rows.map((row, rowIdx) => (
              <tr key={rowIdx}>
                <td>{renderLabel(row)}</td>
                {visibleColumns.map(col => (
                  <td key={col.id}>{renderCellContent(row[col.id])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        ))}
      </table>
    </div>
  );
}

export default PricingTables;
